
import axios from 'axios';
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api',
  withCredentials: true,
  timeout: 10000,
});
axiosInstance.interceptors.request.use((config) => {
  const { store } = require('../store/store');
  const token = store.getState()?.auth?.auth?.accessToken;
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  if (config.data) {
    const isFormData = config.data instanceof FormData;
    if (!isFormData) {
    }
  }
  return config;
}, (error) => Promise.reject(error));
axiosInstance.interceptors.response.use(
  (response) => {
    try {
      const contentType = response.headers['content-type'] || '';
      if (contentType.includes('text/csv') || contentType.includes('application/octet-stream')) {
        return response;
      }
      return response;
    } catch (e) {
      return response;
    }
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      localStorage.removeItem('LNT');
      localStorage.clear();
      if(window.location.pathname!='/'  && window.location.pathname!='/login'){
        alert(window.location.pathname)
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;